module.exports = __webpack_public_path__ + "static/img/device_hy_s1.cfd162a8.png";